// src/utils/visits.js
// Analytics (3.49.0, Super Admins' Analytics page): a small note to our own
// server for each page the portal shows (backend lib/analytics.js). Not
// Google Analytics: nothing goes to anyone else.
//   vid    a random id kept in this browser (new visitor when just made)
//   sid    the visit: a new one after 30 minutes without use
//   page   the page's name (e.g. "dashboard", "users/people", "signin"),
//          never an address with ids in it
//   newVisit  this page starts a visit (counts the visitor's visits)
//   ref    the site that sent them here (first page of a visit only)
//   app    true when opened as the installed app (3.52.0; Analytics shows "App")
// Signed in, the server learns who it is from the usual token; Super Admins
// are counted apart.
import { API_BASE } from '../firebase/config';
import { isInstalledApp } from '../hooks/useInstallApp';

const VID = 'faxPortal.vid', SID = 'faxPortal.visit';
const VISIT_GAP = 30 * 60000;
const rand = () => Array.from(crypto.getRandomValues(new Uint8Array(12)), b => b.toString(16).padStart(2, '0')).join('');
let lastSent = '';

function ids() {
  let vid = null, isNew = false, sid = null, firstOfVisit = false;
  try {
    vid = localStorage.getItem(VID);
    if (!vid) { vid = rand(); localStorage.setItem(VID, vid); isNew = true; }
    const s = JSON.parse(localStorage.getItem(SID) || 'null');
    const now = Date.now();
    if (s && s.id && now - s.last < VISIT_GAP) sid = s.id; else { sid = rand(); firstOfVisit = true; }
    localStorage.setItem(SID, JSON.stringify({ id: sid, last: now }));
  } catch {   // storage blocked: count the page, as a one-off visitor
    vid = vid || rand(); sid = sid || rand(); firstOfVisit = true;
  }
  return { vid, isNew, sid, firstOfVisit };
}

// page: its name; getToken (optional): the signed-in person's token
export async function trackPage(page, getToken = null) {
  // 3.49.13: the development copy (npm start, the layout preview) never
  // counts as a visitor in the live analytics
  if (process.env.NODE_ENV !== 'production') return;
  if (!page) return;
  const { vid, isNew, sid, firstOfVisit } = ids();
  // The same page twice in a row within a second (React re-running an
  // effect) counts once
  const k = `${sid}|${page}|${Math.floor(Date.now() / 1000)}`;
  if (k === lastSent) return;
  lastSent = k;
  try {
    const headers = { 'Content-Type': 'application/json' };
    if (getToken) { try { const t = await getToken(); if (t) headers.Authorization = `Bearer ${t}`; } catch { /* count as signed out */ } }
    await fetch(`${API_BASE}/portal/visit`, {
      method: 'POST', headers, keepalive: true,
      body: JSON.stringify({ vid, sid, page, isNew, newVisit: firstOfVisit, ref: firstOfVisit ? document.referrer || '' : '', ...(isInstalledApp() ? { app: true } : {}) }),   // 3.52.0: from the installed app
    });
  } catch { /* never in the way */ }
}
